export const deploymentAccounts = [
    {
        accountId: '125996965743',
        accountName: 'flexi-tools',
    },
    {
        accountId: '152633770454',
        accountName: 'flexi-shared-svcs-dev',
    },
    {
        accountId: '951377762314',
        accountName: 'flexi-shared-svcs-test',
    },
    {
        accountId: '477488528677',
        accountName: 'flexi-shared-svcs-prod',
    },
];
